import { useEffect, useState } from 'react';
import useIsFocused from './useIsFocused.js';

const useKeys = () => {
  const [isMeta, setIsMeta] = useState(false);
  const focused = useIsFocused();

  useEffect(() => {
    if (!focused) setIsMeta(false);
  }, [focused]);

  useEffect(() => {
    const handleKeyDown = event => {
      if (event.key === 'Meta') setIsMeta(true);
    };

    const handleKeyUp = event => {
      if (event.key === 'Meta') setIsMeta(false);
    };

    const handleVisbilityChange = () => {
      setIsMeta(false);
    };

    document.addEventListener('keydown', handleKeyDown);
    document.addEventListener('keyup', handleKeyUp);
    document.addEventListener('visibilitychange', handleVisbilityChange);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      document.removeEventListener('keyup', handleKeyUp);
      document.removeEventListener('visibilitychange', handleVisbilityChange);
    };
  }, []);

  return { isMeta };
};

export default useKeys;
